import type { Catalog } from "../../en";

export const agentKnowledge: Catalog["build"]["agentKnowledge"] = {
  title: "Kaalaman",
  hint: "Piliin kung aling mga source ng workspace ang pinagbabatayan ng sagot ng agent na ito, at kung sino ang puwedeng bumasa sa bawat isa.",
  summaryLabel: "Sino ang nakakakita ng ano",
  guestsCan_one: "Nakikita ng mga guest ang {{count}} source",
  guestsCan_other: "Nakikita ng mga guest ang {{count}} source",
  membersCan_one: "Nakikita ng mga naka-sign-in ang {{count}} source",
  membersCan_other: "Nakikita ng mga naka-sign-in ang {{count}} source",
  summaryNote: "Binibilang ang mga source na gamit ng agent na ito at handa na, matapos ilapat ang limitasyong “Sino ang puwedeng makipag-chat”.",
  capHint: "Nililimitahan ng “Sino ang puwedeng makipag-chat” ang agent na ito sa {{levels}}. Ang nababasa lang ng bisita ay mga source na bukas sa kanila at nasa loob ng limitasyong iyon.",
  capNoGuests: "Hindi magagamit ng mga guest ang agent na ito: hindi kasama ang {{label}} sa “Sino ang puwedeng makipag-chat”.",
  testGuest: "Subukan bilang guest",
  testSignedIn: "Subukan bilang naka-sign-in",
  testHint: "Bubuksan ang Playground gamit ang audience na iyon, para makita mo mismo ang makukuha nila.",
  listTitle: "Mga source",
  listHint: "Lahat ng source sa workspace. Nasa source ang access, kaya kahit saan ito gamitin ay nag-aapply ang pagbabago rito.",
  manage: "Buksan ang Knowledge Base",
  caption: "Mga knowledge source ng workspace",
  cols: { use: "Gamitin sa agent na ito", source: "Source", status: "Status", chunks: "Mga chunk", access: "Sino ang puwedeng bumasa" },
  useIn: "Gamitin ang {{name}} sa agent na ito",
  usedOn: "Gamit na ng agent na ito ang {{name}}",
  usedOff: "Hindi na gamit ng agent na ito ang {{name}}",
  accessFor: "Sino ang puwedeng bumasa ng {{name}}",
  access: {
    everyone: "Lahat, kasama ang mga guest",
    signed_in: "Mga naka-sign-in",
    staff: "Staff lang",
    custom: "Custom…",
    customNamed: "Custom: {{labels}}",
  },
  editCustom: "I-edit ang access ng {{name}}",
  editCustomShort: "I-edit",
  accessSaved: "Na-update ang access ng {{name}}",
  appliesAll_one: "Nag-aapply sa {{count}} agent na gumagamit ng source na ito",
  appliesAll_other: "Nag-aapply sa lahat ng {{count}} agent na gumagamit ng source na ito",
  appliesNone: "Wala pang agent na gumagamit ng source na ito",
  needsEdit: "Kailangan ng pahintulot na mag-edit ng Knowledge para baguhin kung sino ang puwedeng bumasa ng source. Magtanong sa admin ng workspace.",
  needsLink: "Kailangan ng pahintulot na mag-edit ng agent para mapili kung aling mga source ang gamit nito.",
  piiConfirm: {
    title: "Gawing nakikita ng lahat ang “{{name}}”?",
    body: "Mukhang may {{kinds}} ang source na ito. Mababasa ng lahat, pati ng mga hindi pa naka-sign-in, ang mga sagot na ibinatay dito.",
    confirm: "Gawing nakikita ng lahat",
    cancel: "Panatilihing pribado",
  },
  summaryLive: "{{guests}} source ang nakikita ng mga guest, {{members}} ang nakikita ng mga naka-sign-in.",
  empty: {
    title: "Wala pang knowledge source",
    body: "Magdagdag ng mga dokumento, website o Q&A sa Knowledge Base, saka piliin dito. Sa ginagamit lang nito nagbabatay ang sagot ng agent.",
    cta: "Magdagdag ng kaalaman",
  },
  error: { title: "Hindi nai-load ang Kaalaman", body: "Suriin ang koneksyon at subukan muli. Walang nabago." },
  forbidden: { title: "Hindi mo makikita ang mga knowledge source", body: "Hindi kasama sa role mo ang pagtingin sa Knowledge Base. Magtanong sa admin ng workspace kung kailangan mo ito." },
};
